import { signIn } from "../lib/auth";

export default function Login() {
  return (
    <div class="login">
      <div class="login-card">
        <h1>Ocean Admin</h1>
        <p class="muted">Sign in with your team account.</p>
        <button class="primary" onClick={() => signIn()}>
          Continue with WorkOS
        </button>
      </div>
    </div>
  );
}
